<template>
  <div class="popupBox">
    <van-popup
      class="express_content"
      v-model="show_title"
      position="center"
      round
      :style="{ height: '23.44rem',width:'18.13rem' }"
    >
      <div class="top_box">
        <p class="tip_img">
          <img src="../../assets/images/doctor/box1.png" alt="">
        </p>
        <p class="tip_title">请确认以下是开给您或亲属的处方!</p>
        <div class="tip_info">
          <dl>
            <dt><img :src="data.doctor_avatar?data.doctor_avatar:''" alt=""></dt>
            <dd>
              {{ data.doctor_name ? data.doctor_name : '' }}医生为{{ data.patient_name ? data.patient_name : '' }}开出的处方单
            </dd>
          </dl>
        </div>
        <div class="xieyi">
          <div>
            <van-checkbox v-model="checked">
              <img
                slot="icon"
                slot-scope="props"
                :src="props.checked ? activeIcon : inactiveIcon"
              />
            </van-checkbox>
          </div>
          <div>
            阅读并同意 <a style="color: #AC4B38" @click="yonghu(1)">《用户协议》</a>、 <a style="color: #AC4B38"
                                                                                       @click="yonghu(2)">《问诊协议》</a>及
            <a style="color: #AC4B38" @click="yonghu(3)">《隐私政策》</a>
          </div>
        </div>
        <div class="botton">
          <button class="ok" @click="checkOk">确认并查看处方</button>
          <p class="cancel" @click="checkCancel">离开</p>
        </div>
      </div>

    </van-popup>
    <Loading :value="show"/>
  </div>
</template>

<script>
import xuanze from '../../assets/images/doctor/check.png'
import weixuanze from '../../assets/images/doctor/weixuanze.png'
import {deviceType} from '../../util/deviceType'
import http2 from '../../util/hermerApiConfig'
import http3 from '../../util/iapetusApiConfig'
import VConsole from 'vconsole'
import Loading from '../loading/loading'

export default {
  components: {
    Loading
  },
  data() {
    return {
      show: true,
      show_title: false,
      is_baoan: false,
      checked: false,
      activeIcon: xuanze,
      inactiveIcon: weixuanze,
      data: {},
      is_weixin: deviceType.isWeiXin,
      diagnosis_prescription_id: '',
      platform_type: '1',
    }
  },
  mounted() {
    this.isApp = this.$appUtils.isApp()
    if (this.isApp == 'IOS') {
      let bridge = window.WebViewJavascriptBridge
      bridge.callHandler('getUserInfo', '', response => {
        this.user_id = response.user_id
        this.token = response.token
        this.platform_type = response.platform_type
      })
    } else if (this.isApp == 'android') {
      let user_info = this.$appUtils.appData()
      if (user_info) {
        this.user_id = user_info.user_id
        this.token = user_info.token
        this.platform_type = user_info.platform_type
      }
    } else if (this.$route.query.is_mini) {
      this.token = this.$route.query.token
      this.user_id = this.$route.query.user_id
      this.doctor_user_id = this.$route.query.doctor_user_id
      this.is_mini = true
      this.platform_type = '1'
    } else if (this.$route.query.is_baoan) {
      this.show_title = true
      setTimeout(() => {
        this.token = this.$route.query.token
        this.user_id = this.$route.query.user_id
        localStorage.setItem('user_id',this.$route.query.user_id)
        localStorage.setItem('token',this.$route.query.token)
        setTimeout(()=>{
          if (location.href.indexOf("#") == -1) {
            //在当前页面地址加入"#"，使下次不再进入此判断
            location.href = location.href + "#";
            location.reload();
          }
        },100)
      }, 500)
      this.user_id = this.$route.query.user_id
      this.doctor_user_id = this.$route.query.doctor_user_id
      this.is_baoan = true
      this.platform_type = '1'
    } else {
      this.show_title = true
      this.user_id = localStorage.getItem('user_id')
      this.token = localStorage.getItem('token')
      this.platform_type = '1'
    }
    let doctor_id = this.$route.query.doctor_id
    if (doctor_id) {
      this.doctor_id = doctor_id
    }
    if (this.$route.query.diagnosis_prescription_id) {
      this.diagnosis_prescription_id = this.$route.query.diagnosis_prescription_id
    } else {
      this.diagnosis_prescription_id = this.$route.query.id
    }
    if (this.is_weixin && !this.is_mini) {
      if (this.diagnosis_prescription_id) {
        http3.get('feature/diagnosis/prescriptions/' + this.diagnosis_prescription_id).then(res => {
          if (res.data.status_code == 200) {
            if (res.data.data.is_show == 1) {
              this.ttt = true
              new VConsole()
            }
          }
        })
      }
    }

    setTimeout(() => {
      this.show = true
      this.getinit()
    }, 1000)
  },
  methods: {

    yonghu(type) {
      // 查看协议
      http2.get('/protocol?type=' + type).then(res => {
        window.location.href = res.data.data.url
      })
    },
    getinit() {
      http3.get('/prescription/' + this.$route.query.diagnosis_prescription_id + '/doctor/info').then(res => {
        if (res.data.status_code == 200) {
          this.data = res.data.data
          setTimeout(() => {
            this.show = false
          }, 200)
        }
      })
    },
    checkOk() {
      if (this.checked) {
        let url = ''
        if (deviceType.isDoctor) {
          url =
            'studio/doctors/' +
            this.doctor_id +
            '/diagnosis_prescriptions/' +
            this.diagnosis_prescription_id +
            '?platform_type=' +
            this.platform_type
        } else {
          url =
            '/diagnosis_prescriptions/' +
            this.diagnosis_prescription_id +
            '?platform_type=' +
            this.platform_type
        }
        console.log(this.token, 'token')
        http3
          .get(url, {
            headers: {
              Authorization: this.token
            }
          }).then(res => {
          if (res.data.status_code == 200) {
            if (this.is_weixin) {
              this.$router.push({
                path: "/prescriptionlist",
                query: {
                  diagnosis_prescription_id: this.diagnosis_prescription_id,
                  Confirmtype: true,
                  token:this.token
                },
              });
            }else if (this.is_baoan) {
              this.$router.push({
                path: "/prescriptionlist",
                query: {
                  diagnosis_prescription_id: this.diagnosis_prescription_id,
                  token:this.token,
                  user_id:this.user_id,
                  doctor_user_id:this.doctor_user_id,
                  is_baoan:this.is_baoan,
                },
              });
            }else {
              this.$router.push({
                path: "/prescriptionlist",
                query: {
                  diagnosis_prescription_id: this.diagnosis_prescription_id,
                  Confirmtype: true,
                  token:this.token
                },
              });
            }
          } else {
            if (this.is_weixin) {
              this.$router.push({
                path: "/prescriptionlist",
                query: {
                  diagnosis_prescription_id: this.diagnosis_prescription_id,
                  Confirmtype: true,
                  token:this.token
                },
              });
            } else {
              this.$router.push({
                path: "/order_login",
                query: {
                  diagnosis_prescription_id: this.diagnosis_prescription_id,
                  Confirmtype: true,
                  token:this.token
                }
              });
            }
          }
        })
      } else {
        alert('阅读并同意协议')
      }
    },
    checkCancel() {
      window.open('https://dl.zyzk.jiankanghao.net?isTrue=1', '_blank')
    },
  }
}
</script>

<style lang="scss" scoped>
.popupBox {
  width: 100%;
  height: 100%;

  .express_content {
    display: flex;
    flex-direction: column;

    .top_box {
      flex: 1;

      .tip_img {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 1.16rem;

        img {
          width: 3rem;
          height: 3rem;
        }
      }

      .tip_title {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 1.25rem;
        font-size: 1rem;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: #333333;
      }

      .tip_title1 {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 1.25rem;
        font-size: 1.25rem;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: #333333;
      }

      .tip_info {
        width: 100%;
        height: 5.38rem;
        margin-top: 0.81rem;
        display: flex;
        justify-content: center;
        align-items: center;

        dl {
          width: 15.63rem;
          height: 5.38rem;
          background: url("../../assets/images/doctor/box2.png") no-repeat;
          background-size: 100% 100%;
          padding: .75rem;
          box-sizing: border-box;

          dt {
            img {
              width: 2rem;
              height: 2rem;
              border-radius: 50%;
            }
          }

          dd {
            margin-top: .63rem;
            font-size: 0.88rem;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #666666;
          }
        }
      }

      .xieyi {
        display: flex;
        justify-content: center;
        font-size: 0.75rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        padding: .75rem;
        box-sizing: border-box;

        .van-checkbox {
          margin-right: .2rem;
          width: 1.2rem;
          height: 1.2rem;

          img {
            width: 1.2rem;
            height: 1.2rem;
          }
        }
      }

      .botton {
        margin-top: 1.5rem;
        display: flex;
        flex-direction: column;
        align-items: center;

        .ok {
          width: 15.63rem;
          height: 2.5rem;
          background: #AC4B38;
          border-radius: 0.25rem;
          font-size: 1rem;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #FFFFFF;
        }

        .cancel {
          margin-top: .81rem;
          font-size: 1rem;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #AC4B38;
        }
      }
    }

    .bot_box {
      width: 100%;
      height: 8%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/order/order_confirm.vue